import React from "react";
import UnitCard from "./UnitCard";
import { CATEGORIES, REINFORCEMENT_CATEGORY } from "../constants";
import { isCategoryFull } from "../lib/army";

export default function Catalogue({
  faction, factionMeta, filterCategory, setFilterCategory,
  searchTerm, setSearchTerm, currentQtyOf, addUnit, showReinforcements, roster, unlockedUnits,
}) {
  const tabs = ["All", ...CATEGORIES.filter((cat) => cat !== REINFORCEMENT_CATEGORY || showReinforcements)];
  const tabLabel = (cat) => (cat === REINFORCEMENT_CATEGORY ? "Reinforcement Requests" : cat);
  const term = searchTerm.trim().toLowerCase();
  const list = faction
    ? faction.units.filter((u) => {
        const matchesCat = filterCategory === "All" || u.category === filterCategory;
        const matchesTerm = !term || u.name.toLowerCase().includes(term);
        const visible = !u.hiddenUntilUnlocked || unlockedUnits.has(u.id);
        return matchesCat && matchesTerm && visible;
      })
    : [];

  return (
    <section className="col-catalogue" aria-label="Unit catalogue">
      <div>
        <div className="section-eyebrow">Unit catalogue</div>
        <div className="faction-meta" data-testid="faction-meta">
          {faction ? (
            <>
              <b>{faction.name}</b>
              <br />
              {faction.group || ""} {faction.year ? "\u00b7 " + faction.year : ""}
            </>
          ) : (
            factionMeta
          )}
        </div>
      </div>

      <div className="filter-tabs" role="tablist" aria-label="Filter by category">
        {tabs.map((cat) => (
          <button
            key={cat}
            className={"tab" + (filterCategory === cat ? " is-active" : "")}
            role="tab"
            aria-selected={filterCategory === cat}
            onClick={() => setFilterCategory(cat)}
            data-testid={`filter-tab-${cat}`}
          >
            {tabLabel(cat)}
          </button>
        ))}
      </div>

      <div className="search-row">
        <input
          type="search"
          className="search-input"
          placeholder="Search units…"
          aria-label="Search units"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          data-testid="search-input"
        />
      </div>

      <div className="catalogue-list" data-testid="catalogue-list">
        {!faction ? (
          <div className="empty-note">No army loaded yet.</div>
        ) : list.length === 0 ? (
          <div className="empty-note">No units match this filter.</div>
        ) : (
          list.map((unit) => (
            <UnitCard
              key={unit.id}
              unit={unit}
              currentQty={currentQtyOf(unit.id)}
              onAdd={addUnit}
              sectionFull={isCategoryFull(faction, roster, unit.category)}
            />
          ))
        )}
      </div>
    </section>
  );
}
